import React from 'react';
import { X } from 'lucide-react';
import { Filter } from './types';
import { FiltersContainer, FilterTag, RemoveButton, ClearAllButton } from './AppliedFiltersDisplay.style';

interface AppliedFiltersDisplayProps {
  filters: Filter[];
  onRemoveFilter: (index: number) => void;
  onClearAll: () => void;
}

const AppliedFiltersDisplay: React.FC<AppliedFiltersDisplayProps> = ({
  filters,
  onRemoveFilter,
  onClearAll
}) => {
  if (filters.length === 0) return null;

  return (
    <FiltersContainer>
      {filters.map((filter, index) => (
        <FilterTag key={index}>
          <span>{filter.label} {filter.filterType}: {filter.displayValue || filter.value}</span>
          <RemoveButton onClick={() => onRemoveFilter(index)}>
            <X size={12} />
          </RemoveButton>
        </FilterTag>
      ))}
      <ClearAllButton onClick={onClearAll}>
        Limpar todos
      </ClearAllButton>
    </FiltersContainer>
  );
};

export default AppliedFiltersDisplay;